<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition-upper', 'pa-park-area-infomation-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .1}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @afterEnterContent="handleEnterContent"
   @closeOverlayModal="handleCloseOverlay"
   @afteredAfterEnterContent="handleAfterEnterContent"
  >
    <div class="pa-wide-modal-box-wrapper pa-park-area-infomation">
      <div class="pa-wide-modal-box" ref="wideModalBox">
        <div class="park-info">
          <PAParkBanner
           :parkId="parkId"
           :couldExpandDescription="false"
           :couldDisplayAreaInfomationModal="false"
          />
        </div>
        <div class="park-area-status">
          <p class="pa-title">現在のひろば地区</p>
          <p class="pa-text">「{{positionName}}」</p>
        </div>

        <hr class="pa-separator" />

        <div class="next-indicator-board">
          <p class="pa-title">次の地区まで</p>
          <ul class="require-status-list">
            <li v-for="(item,index) in nextRequirePointSet" :key="index">
              <div class="left-field">{{item.left}}</div>
              <div class="middle-field">
                <div class="number-field">
                  <div class="pa-number" :class="item.numberClass">{{item.middle.slot1}}</div>
                </div>
                <div class="number-field">
                  <div class="pa-number" :class="item.numberClass">{{item.middle.slot2}}</div>
                </div>
                <div class="number-field">
                  <div class="pa-number" :class="item.numberClass">{{item.middle.slot3}}</div>
                </div>
                <div class="number-field">
                  <div class="pa-number" :class="item.numberClass">{{item.middle.slot4}}</div>
                </div>
              </div>
              <div class="right-field">{{item.right}}</div>
            </li>
          </ul>
        </div>

        <hr class="pa-separator pa-separator-down" />

        <div class="close-button-field">
          <button
           class="button"
           @click.prevent="handleClickClose"
          >閉じる</button>
        </div>
      </div>
      
      <transition name="pa-simple-fade" @beforeEnter="handleBeforeEnterLoading">
        <div class="pa-loading-set" v-if="isLoading">
          <div class="pa-loading-field" ref="loadingContent">
            <PuffLoadingImage stroke="#957E63" />
          </div>
          <div class="pa-loading-overlay" ref="loadingOverlay"></div>
        </div>
      </transition>
    </div>
  </PaOverlayModal>
</template>

<script>
import PAParkBanner from '@/components/Parts/PAParkBanner/PAParkBanner.vue'

import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PuffLoadingImage from '@/components/Pages/Connections/ConnectionApp/Images/puff.svg?inlineN'

import {GetParkPositionInfoData} from '@/graphql/queries/Park.graphql'

export default {
  components : {
    PAParkBanner,

    PaOverlayModal,
    PuffLoadingImage
  },

  data(){
    return {
      isOpenModal   : false,
      isFreezModal  : false,
      isEnterdModal : false,

      isLoading     : false,
      parkId        : null,

      nextRequirePointSet : {
        character : {
          left        : 'あと',
          middle      : {
            slot1 : null,
            slot2 : null,
            slot3 : null,
            slot4 : null
          },
          right       : 'の異界渡航者',
          numberClass : {
            'pa-number-none'  : true
          }
        },
        park_note : {
          left        : 'あと',
          middle      : {
            slot1 : null,
            slot2 : null,
            slot3 : null,
            slot4 : null
          },
          right       : 'のノート投稿',
          numberClass : {
            'pa-number-none'  : true
          }
        },
        park_note_comment : {
          left        : 'あと',
          middle      : {
            slot1 : null,
            slot2 : null,
            slot3 : null,
            slot4 : null
          },
          right       : 'のコメント投稿',
          numberClass : {
            'pa-number-none'  : true
          }
        },
        park_note_like : {
          left        : 'あと',
          middle      : {
            slot1 : null,
            slot2 : null,
            slot3 : null,
            slot4 : null
          },
          right       : 'の♥付与',
          numberClass : {
            'pa-number-none'  : true
          }
        },
      },

      nextLevelPointTextSet : {
        character         : '',
        park_note         : '',
        park_note_comment : '',
        park_note_like    : '',
      },

      nextLevelPointTextTemplate : {
        character         : 'あと[[count]]人の異界渡航者',
        park_note         : 'あと[[count]]ノート投稿',
        park_note_comment : 'あと[[count]]コメント投稿',
        park_note_like    : 'あと[[count]]♥付与',
      },

      parkName      : null,
      positionName  : null,
    };
  },

  computed : {
    urlQuery(){
      return this.$route.query;
    },

    routerParams(){
      return this.$route.params;
    },

    isDataLoading(){
      return this.$apollo.queries.parkPositionInfo?.loading;
    }
  },

  apollo : {
    parkPositionInfo  : {
      query : GetParkPositionInfoData,

      variables(){
        return {
          park_id  : this.parkId
        }
      },

      skip(){
        if(this.parkId === null){
          return true;
        }else{
          return false;
        }
      },

      result(){
        this.isDataLoaded = true;
      },

      fetchPolicy: 'no-cache'
    }
  },

  watch : {
    routerParams : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(typeof data.parkId !== 'undefined'){
          this.parkId = data.parkId;
        }
      },
      immediate: true,
      deep: true
    },

    urlQuery : {
      handler(data){
        if(typeof data !== 'object') return;

        let couldOpenModal = false;

        if( typeof data.is_open_park_area_infomation_modal !== 'undefined' ){
          if(data.is_open_park_area_infomation_modal === 'yes'){
            couldOpenModal = true;
          }
        }

        this.isEnterdModal = false;

        setTimeout(() => {
          this.isOpenModal = couldOpenModal;
        }, 250);
      },
      immediate: true,
      deep: true
    },

    isDataLoading : {
      handler(value){
        this.isLoading = value;
      }
    },

    parkPositionInfo : {
      handler(data){
        const infoValueList = ['character', 'park_note', 'park_note_comment', 'park_note_like'];

        // for(let i = 0; i < infoValueList.length; i++){
        //   if(data['required_'+infoValueList[i]+'_point'] !== null){
        //     this.nextLevelPointTextSet[infoValueList[i]] = this.$options.filters.templateReplacer(
        //       this.nextLevelPointTextTemplate[infoValueList[i]],
        //       {
        //         count : data['required_'+infoValueList[i]+'_point']
        //       }
        //     );
        //   }
        // }

        for(let i = 0; i < infoValueList.length; i++){
          if(data['required_'+infoValueList[i]+'_point'] !== null){
            const zerofill = data['required_'+infoValueList[i]+'_point'].toLocaleString('en', {minimumIntegerDigits:4,minimumFractionDigits:0,useGrouping:false});

            this.nextRequirePointSet[infoValueList[i]].middle.slot1 = zerofill[0];
            this.nextRequirePointSet[infoValueList[i]].middle.slot2 = zerofill[1];
            this.nextRequirePointSet[infoValueList[i]].middle.slot3 = zerofill[2];
            this.nextRequirePointSet[infoValueList[i]].middle.slot4 = zerofill[3];
            this.nextRequirePointSet[infoValueList[i]].numberClass['pa-number-none'] = false;
          }else{
            this.nextRequirePointSet[infoValueList[i]].middle.slot1 = null;
            this.nextRequirePointSet[infoValueList[i]].middle.slot2 = null;
            this.nextRequirePointSet[infoValueList[i]].middle.slot3 = null;
            this.nextRequirePointSet[infoValueList[i]].middle.slot4 = null;
            this.nextRequirePointSet[infoValueList[i]].numberClass['pa-number-none'] = true;
          }
        }

        this.parkName      = data.park.name;
        this.positionName  = data.park.park_level.position_name;
        this.positionName += data.park.park_level.position_area_name;
      }
    }
  },

  methods : {
    handleClickClose(){
      this.isOpenModal = false;
    },
    
    handleCloseModal(){
      this.isOpenModal = false;
    },

    handleCloseOverlay(){
      this.isOpenModal = false;

      const newUrlQuery = Object.assign({}, this.$route.query);

      if(newUrlQuery['y'] === 0){
        delete newUrlQuery.y;
      }

      delete newUrlQuery.is_open_park_area_infomation_modal;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    handleEnterContent(){
      this.$apollo.queries.parkPositionInfo.refetch();
    },

    handleAfterEnterContent(){
      this.$nextTick(() => {
        this.isEnterdModal = true;
      });
    },

    handleBeforeEnterLoading(){
      const boxHeight = this.$refs.wideModalBox.offsetHeight;

      this.$refs.loadingContent.style.height = boxHeight + 'px';
      this.$refs.loadingOverlay.style.height = boxHeight + 'px';
    },
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-park-area-infomation{
  .park-info{
    width:95%;
    margin:12px auto 0;
  }

  .park-area-status{
    padding:1rem 0;

    @include until(375px) {
      padding:.5rem 0 .3rem;
    }

    p{
      text-align: center;
      color:#513F28;

      &.pa-title{
        font-size:.8rem;

        @include until(375px) {
          font-size:.7rem;
        }
      }

      &.pa-text{
        margin-top:.3rem;
        font-size:1.2rem;

        @include until(375px) {
          margin-top:.1rem;
          font-size:1rem;
        }
      }
    }
  }

  hr.pa-separator{
    width:95%;
    margin:0 auto;
    background-color: #C1A582;

    &-down{
      margin-top:1rem;

      @include until(375px) {
        margin-top:.5rem;
      }
    }
  }

  .next-indicator-board{
    width:95%;
    margin:1rem auto 0;
    background-color: #A27A47;
    border-radius: 8px;
    color:#CEB18B;

    @include until(375px) {
      margin:.5rem auto 0;
    }
    
    p.pa-title{
      color:#6A5132;
      font-size: 1.3rem;
      letter-spacing: 2px;
      padding:8px 0;
      text-align: center;
      border-bottom:1px solid #AA804A;
      // font-family: 'mplus-1m-regular';

      @include until(375px) {
        font-size: 1.1rem;
        padding:5px 0 6px;
      }
    }
    
    ul.require-status-list{
      li{
        display: flex;
        flex-direction: row;
        font-size:1.1rem;
        border-bottom:1px solid #AA804A;

        @include until(375px) {
          font-size:.9rem;
        }

        &:last-child{
          border-bottom: 0;
        }

        > div{
          box-sizing: border-box;
          padding:8px;

          &.left-field{
            width:20%;
          }

          &.middle-field{
            padding:0;
            width:30%;
            border-left:2px solid #AA804A;
            border-right:2px solid #AA804A;
            display: flex;
            flex-direction: row;
            align-items: stretch;
            align-content: space-between;

            .number-field{
              width:25%;
              border-right: 2px solid #AA804A;
              text-align: center;
              display: flex;
              align-items: center;
              position: relative;

              .pa-number{
                width:100%;
                text-align: center;
                font-size: 1.6rem;

                &-none{
                  &::after{
                    display: block;
                    margin-top:-4px;
                    content: "-";
                  }
                }
              }

              &:last-child{
                border-right:none;
              }

              &::after{
                position: absolute;
                top:0;
                width:100%;
                height:52%;
                border-bottom:1.5px solid #AA804A;
                content:" ";
              }
            }
          }

          &.right-field{
            width:50%;
          }
        }
      }
    }
  }

  .close-button-field{
    margin:1rem 0;
    text-align: center;

    @include until(375px) {
      margin:.5rem 0;
    }

    button.button{
      margin:0 auto;
      padding:0;
      height: inherit;
      border:0;
      border-radius: 0;
      background-color: inherit;
      font-size: 1.1rem;
      border-bottom: 2px solid #242424;

      @include until(375px) {
        font-size: 1rem;
      }
    }
  }
}
</style>